import { useState } from "react";
import { Navigate } from "react-router-dom";
import useTrackWebContext from "../../../hooks/useTrackWebContext";
import SaleModal from "../Modal/SaleModal";
import InputSpinner from "../../common/InputSpinner";
import { ValidateUserDni } from "../../../utilities/instanceCredentials";
import instanceCommerce from "../../../config/instanceCommerce.js";
import { UserActivityDay } from "../../../utilities/servicesTrackWeb";

const RegisterSale = () => {
  const {
    token,
    infoCommerce,
    dataCommerce,
    modal,
    handleModalClick,
    isLogin,
  } = useTrackWebContext();

  const [userDni, setUserDni] = useState("");
  const [amount, setAmount] = useState("");
  const [promotion, setPromotion] = useState("usual");
  const [discountType, setDiscountType] = useState("pesos");
  const [discount, setDiscount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const [processedAmount, setprocessedAmount] = useState(0);
  const [processedDiscount, setprocessedDiscount] = useState(0);

  const [modalData, setModalData] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    if ([userDni, amount].includes("")) {
      setModalData({
        error: true,
        msg: "El Dni y el Importe son obligatorios",
      });
      handleModalClick();
      setIsLoading(false);
      return;
    }

    if (
      promotion === "special" &&
      discountType === "pesos" &&
      parseFloat(amount) < parseFloat(discount)
    ) {
      setModalData({
        error: true,
        msg: "El descuento a aplicar no puede ser mayor al monto de la compra",
      });
      handleModalClick();
      setIsLoading(false);
      return;
    }

    const processedDiscount = await processDiscount(
      promotion,
      infoCommerce,
      amount,
      discountType,
      discount
    );
    setprocessedDiscount(processedDiscount);

    const userDataApi = await ValidateUserDni(userDni);
    if (userDataApi.status === 0) {
      setModalData({
        error: true,
        msg: userDataApi.message,
      });
      handleModalClick();
      setUserData({});

      setIsLoading(false);
      return;
    } else {
      setUserData(userDataApi);
    }

    const dataUserActivityDay = await UserActivityDay(
      userDni,
      token,
      dataCommerce
    );
    if (!dataUserActivityDay.success) {
      setModalData({
        error: true,
        msg: dataUserActivityDay.msg,
      });
      handleModalClick();
      setIsLoading(false);
      return;
    }
    const userActivityDay = dataUserActivityDay.data;

    const descuentosUsuario = userActivityDay
      ?.map((transaccion) => parseFloat(transaccion?.importe_descuento) || 0)
      .reduce((acumulador, importe) => acumulador + importe, 0);

    // Validaciones de montos y descuentos del usuario
    if (
      infoCommerce?.tope_de_monto !== null &&
      (descuentosUsuario >= infoCommerce.tope_de_monto ||
        descuentosUsuario + processedDiscount >= infoCommerce.tope_de_monto)
    ) {
      setModalData({
        error: true,
        msg: "El usuario superó el tope de descuento del comercio",
      });
      handleModalClick();
      setIsLoading(false);
      return;
    }

    const { credential, first_name, last_name } = userDataApi;
    const { nombre_marca, nro_comercio } = infoCommerce;
    const processedAmount = parseFloat(amount) - processedDiscount;
    setprocessedAmount(processedAmount);

    const body = {
      dni_suscriptor: parseInt(userDni),
      nombre_suscriptor: `${first_name} ${last_name}`,
      nro_comercio: parseInt(nro_comercio),
      marca: nombre_marca,
      importe_compra: parseFloat(amount),
      credencial_asociada: credential,
      importe_total: parseFloat(processedAmount),
      importe_descuento: parseFloat(processedDiscount),
      tope: 0,
      descuento_aplicar: promotion === "usual" ? 1 : 0,
      porcentaje:
        promotion === "usual"
          ? parseFloat(infoCommerce.descuento)
          : discountType === "pesos"
          ? 0
          : parseFloat(discount),
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const { data } = await instanceCommerce.post(
        "/api/createpay",
        body,
        config
      );
      if (data.success) {
        setModalData({
          error: false,
          msg: data.message,
          transaction_id: data.transaction_id,
          userData,
          amount,
          processDiscount,
          processedAmount,
        });
        handleModalClick();
        setIsLoading(false);
      }
    } catch (error) {
      setModalData({
        error: true,
        msg: "Error al generar la venta",
      });
      handleModalClick();
      setIsLoading(false);
    }
  };

  const processDiscount = async (
    promotion,
    commerce,
    amount,
    discountType,
    discount
  ) => {
    if (promotion === "usual" && amount > 0) {
      const discountRate =
        (parseFloat(commerce.descuento) * parseFloat(amount)) / 100;
      return discountRate;
    } else if (promotion === "special" && amount > 0) {
      if (discountType === "pesos") {
        return parseFloat(discount);
      } else if (discountType === "porcentaje" && amount > 0) {
        const discountRate = (parseFloat(discount) * parseFloat(amount)) / 100;
        return discountRate;
      }
    }
  };

  const PromotionState = (promotionValue) => {
    setPromotion(promotionValue);
    setDiscountType("");
    setDiscount(0);
  };

  const cleanUpActivity = () => {
    setUserDni("");
    setAmount("");
    setPromotion("usual");
    setDiscount(0);
    setUserData({});
    setprocessedAmount(0);
    setprocessedDiscount(0);
    // setCleanSale(false);
  };

  // useEffect(() => {
  //   if (cleanSale) {
  //     cleanUpActivity();
  //   }
  // }, [cleanSale]);

  return (
    <>
      {!isLogin && <Navigate to="/login" replace={true} />}
      <form
        className="
          min-h-[75%] rounded-[3px] shadow-md shrink-0 static block mx-4 mt-4 mb-10 px-5 pt-5 pb-2 bg-white
          md:w-full md:mx-0 md:mt-0 md:px-[30px] md:pt-[25px] md:pb-[16px]
          lg:w-[600px] lg:ml-5
          xl:w-[830px] xl:ml-[50px]"
        onSubmit={handleSubmit}
      >
        <div className="mb-2 md:mb-4">
          <h2 className="font-bold text-2xl text-clvblue">Registrar venta</h2>
          <p className="font-normal text-base leading-tight text-gray-900">
            Ingresá el DNI de la persona que utilizará la promoción
          </p>
        </div>
        <div className="flex flex-col mt-8">
          <label
            className=" text-gray-400 block font-bold text-xl"
            htmlFor="dni"
          >
            DNI
          </label>
          <input
            id="dni"
            type="number"
            // TODO: Sacar las flechitas del type number.
            className="appearance-none xl:w-3/4 w-full my-2 px-4 py-2 rounded-full border border-gray-400 bg-white placeholder-gray-400 font-body text-xl  focus:rounded-full focus:border-1 focus:bg-neutral-50 focus:border-clvblue "
            placeholder="Ingresar DNI"
            value={userDni}
            onChange={(e) => setUserDni(e.target.value)}
          />
        </div>
        <div className="xl:w-3/4 md:my-3 items-center justify-between">
          <label
            className=" text-gray-400 block font-bold text-xl mt-5"
            htmlFor="dni"
          >
            Datos del descuento
          </label>
          <div className="flex items-center my-2 gap-5 justify-between">
            <label
              className="pr-2 font-bold text-lg leading-tight"
              htmlFor="amount"
            >
              Importe sin descuento
            </label>
            <div className="flex flex-row items-center flex-grow">
              <span className="mr-2 text-lg font-bold text-gray-400">$</span>
              <input
                id="amount"
                type="number"
                className="w-full my-2 px-4 py-2 rounded-full border border-gray-400 bg-white placeholder-gray-400 font-body text-xl  focus:rounded-full focus:border-1 focus:bg-neutral-50 focus:border-clvblue appearance-none"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
          </div> 
            <p className="md:pt-2 font-normal text-xs md:text-sm leading-tight">
              * Se coloca el número de corrido y en caso de que contenga centavos se separan con una coma.
            </p>
        </div>

        <div className="my-4 flex flex-col justify-between">
          <div className="flex items-center md:mb-2">
            <input
              id="promo-option-1"
              type="radio"
              name="promotion"
              value="usual"
              className="w-4 h-4"
              onChange={(e) => PromotionState(e.target.value)}
              defaultChecked
            />
            <label className="block ml-2 text-lg font-bold text-gray-900 dark:text-gray-400">
              Promoción habitual
            </label>
          </div>
          <div className="flex items-center">
            <input
              id="promo-option-2"
              type="radio"
              name="promotion"
              value="special"
              className="w-4 h-4"
              onChange={(e) => setPromotion(e.target.value)}
            />
            <label className="block ml-2 text-lg font-bold text-gray-900 dark:text-gray-400">
              Promoción especial *
            </label>
          </div>
          <div>
            <p className="md:pt-2 font-normal text-xs md:text-sm leading-tight">
              * Activar sólo en caso de promociones especiales diferentes a la
              habitual.
            </p>
          </div>
        </div>
        {promotion === "special" && (
          <div className="flex items-center my-2 gap-5">
            <label className="pr-2 font-bold text-lg leading-tight">
              Descuento a aplicar
            </label>
            <div className="flex flex-col md:flex-row">
              <div className="flex items-center justify-center md:mr-5">
                <input
                  type="radio"
                  id="value-1"
                  name="discountType"
                  value="pesos"
                  className="w-4 h-4"
                  onChange={(e) => setDiscountType(e.target.value)}
                  defaultChecked
                />
                <label className="block ml-1 text-lg font-bold text-gray-400">
                  $
                </label>
                <input
                  type="radio"
                  id="value-2"
                  name="discountType"
                  value="porcentaje"
                  className="w-4 h-4 ml-4"
                  onChange={(e) => setDiscountType(e.target.value)}
                />
                <label className="block ml-1 text-lg font-bold text-gray-900 dark:text-gray-400">
                  %
                </label>
              </div>
              <div>
                <input
                  type="number"
                  name="sell-import"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                  className="w-36 my-2 px-4 py-2 rounded-full border border-gray-500 bg-[#fff] placeholder-gray-500 font-normal font-body focus:rounded-full  focus:bg-neutral-50 focus:border-clvblue"
                />
              </div>
            </div>
          </div>
        )}

        {isLoading && <InputSpinner text={"Procesando"} />}

        {!isLoading && (
          <div className="xl:w-3/4 my-4 md:mb-4 flex justify-center">
            <input
              type="submit"
              value="Registrar venta"
              className={`${
                !userDni || !amount
                  ? "disabled:bg-gray-300 disabled:cursor-not-allowed"
                  : ""
              } rounded-full w-full px-4 py-2 text-xl font-bold  bg-clvblue text-white hover:cursor-pointer hover:bg-clvHoverBlue`}
              disabled={!userDni || !amount}
            />
          </div>
        )}
        {modal && (
          <SaleModal
            modal={modalData}
            token={token}
            userData={userData}
            amount={amount}
            processedDiscount={processedDiscount}
            processedAmount={processedAmount}
            cleanUpActivity={cleanUpActivity}
          />
        )}
      </form>
    </>
  );
};
export default RegisterSale;
